import EmptyState from '@hellodarwin/app-core/lib/components/common/empty-state';
import ContactAdvisorModal from '@hellodarwin/core/lib/components/programs/single/contact-advisor-modal';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import { useState } from 'react';
import { useTheme } from 'styled-components';
import { EmptyProjectsContainer } from './styles';

export interface EmptyProjectsProps {}

const EmptyProjects: React.FC<EmptyProjectsProps> = () => {
  const theme = useTheme();
  const { t } = useTranslations();

  const [contactAdvisorModalOpen, setContactAdvisorModalOpen] = useState(false);
  const handlecontactAdvisorModal = () =>
    setContactAdvisorModalOpen(!contactAdvisorModalOpen);

  return (
    <EmptyProjectsContainer>
      <EmptyState
        title={t('emptyProject|emptyProjectTitle')}
        description={t('emptyProject|emptyProjectSubtitle')}
        cta={{
          children: t('emptyProject|emptyProjectCta'),
          to: '/contact-advisor',
          defaultStyle: theme.colors.yellow_1,
          onClick: handlecontactAdvisorModal,
          tablet: { fullWidth: true },
          size: 'medium',
        }}
      />

      <ContactAdvisorModal
        open={contactAdvisorModalOpen}
        handleCancel={handlecontactAdvisorModal}
      />
    </EmptyProjectsContainer>
  );
};

export default EmptyProjects;
